module.exports = __webpack_public_path__ + "img/number-black-21.8c84607b.png";